export const REGEXP_NUMBER = /^\d+$/;
export const REGEXP_KATAKANA = /^[\u30A0-\u30FF]+$/;
export const REGEXP_ALPHABET = /^[a-zA-Z]+(?: [a-zA-Z]+)*$/;
export const REGEXP_REMOVE_SPACE = / /g;
export const REGEXP_FORMAT_CARD_NUMBER = /(\d{4})(?=\d)/g;
